import * as i0 from "@angular/core";
export class InputStore {
}
InputStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InputStore_Factory() { return new InputStore(); }, token: InputStore, providedIn: "root" });
export var InputStoreKeys;
(function (InputStoreKeys) {
})(InputStoreKeys || (InputStoreKeys = {}));
